module.exports = __webpack_public_path__ + "img/7.839b2651.jpg";